import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { Wiki as WikiComponent } from 'app/containers/Wiki/Wiki.jsx';
import resources from 'app/store/resources/index.js';
import { useSelector } from 'react-redux';
import { assetsResourcesSelector } from 'app/store/selectors/assets';
export function Wiki(props) {
    var _a;
    const { history, match, location } = props;
    const assets = useSelector(assetsResourcesSelector);
    const rootAssetId = (_a = Object.values(assets).find((asset) => asset.name === 'root')) === null || _a === void 0 ? void 0 : _a.id;
    const formatRoute = useCallback((projectId, assetId, artcileVersionId, search) => `/assets-wiki${assetId ? `/${assetId}` : ''}${artcileVersionId ? `/${artcileVersionId}` : ''}${search || ''}`, []);
    useEffect(() => {
        resources.assets.fetchRoot();
    }, []);
    return (_jsx(WikiComponent, { formatRoute: formatRoute, rootAssetId: rootAssetId || '', history: history, match: match, location: location }));
}
